module.exports = __webpack_public_path__ + "static/media/cloudcomputing.4e2ff75c.png";